var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 10.7344C19.0625 12.5573 18.6719 14.1849 17.8906 15.6172C17.1094 17.0495 16.0026 18.1693 14.5703 18.9766C13.1641 19.7839 11.5365 20.1875 9.6875 20.1875C7.94271 20.1875 6.32812 19.7448 4.84375 18.8594C3.35938 18 2.17448 16.8281 1.28906 15.3438C0.429688 13.8594 0 12.2448 0 10.5C0 8.75521 0.429688 7.14062 1.28906 5.65625C2.17448 4.17188 3.35938 3 4.84375 2.14062C6.32812 1.25521 7.94271 0.8125 9.6875 0.8125C12.2135 0.8125 14.375 1.65885 16.1719 3.35156L13.5547 5.89062C12.7214 5.08333 11.7188 4.60156 10.5469 4.44531C9.45312 4.28906 8.3724 4.44531 7.30469 4.91406C6.23698 5.38281 5.3776 6.08594 4.72656 7.02344C4.02344 8.03906 3.67188 9.19792 3.67188 10.5C3.67188 11.6198 3.94531 12.6484 4.49219 13.5859C5.03906 14.4974 5.76823 15.2396 6.67969 15.8125C7.59115 16.3594 8.59375 16.6328 9.6875 16.6328C10.8594 16.6328 11.888 16.3724 12.7734 15.8516C13.4766 15.4349 14.0625 14.875 14.5312 14.1719C14.8698 13.599 15.0911 13.026 15.1953 12.4531H9.6875V9.09375H18.9062C19.0104 9.66667 19.0625 10.2135 19.0625 10.7344Z",
    fill: "#1312DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ffa7fe52dfe32ffdec5d1a913fd6d92b.svg";
export { ForwardRef as ReactComponent };